import { Methods } from '@newview/infrastructure';
import { DbCenterBaseApi } from "../DbCenterBaseApi";

export class DbunbackApi extends DbCenterBaseApi {

  public get ControllerName(): any {
    return 'db-back';
  }

  public getList(dbId, prod) {
    return this.send({ dbId: dbId, prod: prod }, "getList", Methods.GET)
  }

  /**
   * 
   * @param id 提交还原
   * @returns 
   */
  public unback(id) {
    return this.send({ id: id }, "unback", Methods.GET)
  }

}